import { useEffect, useState } from 'react';
export function useCanvasOrientation(canvasWidth, canvasHeight) {
    const [canvasOrientation, setCanvasOrientation] = useState('landscape');
    const [canvasAspectRatioConversion, setCanvasAspectRatioConversion] = useState(canvasWidth / canvasHeight);
    useEffect(() => {
        const newCanvasOrientation = canvasHeight > canvasWidth ? 'portrait' : 'landscape';
        const newCanvasAspectRatioConversion = canvasWidth / canvasHeight;
        if (newCanvasOrientation !== canvasOrientation) {
            setCanvasOrientation(newCanvasOrientation);
            setCanvasAspectRatioConversion(newCanvasAspectRatioConversion);
            document.documentElement.style.setProperty('--aspect-ratio-conversion', newCanvasAspectRatioConversion + '');
        }
        if (newCanvasOrientation === canvasOrientation &&
            canvasAspectRatioConversion !== newCanvasAspectRatioConversion) {
            setCanvasAspectRatioConversion(newCanvasAspectRatioConversion);
            document.documentElement.style.setProperty('--aspect-ratio-conversion', newCanvasAspectRatioConversion + '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canvasWidth, canvasHeight]);
    return canvasAspectRatioConversion;
}
//# sourceMappingURL=use_canvas_orientation.js.map